// extracted by mini-css-extract-plugin
module.exports = {"SearchBarWithDropdown":"vY02VVKr"};